import BookingForm from "./BookingForm";

const Booking = () => {
    return (
        <section className="booking-section">
                <h2>Easy & Quick Booking</h2>
                <BookingForm />
              </section>
    );
};

export default Booking;